import Vue from 'vue'
import {store} from '@/store.js'
import Router from 'vue-router'
import { vuexOidcCreateRouterMiddleware } from 'vuex-oidc'

//lazyload components
const NavigatorLogin = resolve => require(['@/views/NavigatorLogin.vue'], resolve);
const NavigatorDataDashboard = resolve => require(['@/views/NavigatorDataDashboard.vue'], resolve);
const NavigatorActivityDownloader = resolve => require(['@/views/NavigatorActivityDownloader.vue'], resolve);
const NavigatorScriptDownloader = resolve => require(['@/views/NavigatorScriptDownloader.vue'], resolve);
const NavigatorDeviceHealth = resolve => require(['@/views/NavigatorDeviceHealth.vue'], resolve);
//const NavigatorDataHub = resolve => require(['@/views/NavigatorDataHub.vue'], resolve);
const NavigatorDataDeleter = resolve => require(['@/views/NavigatorDataDeleter.vue'], resolve);
const NavigatorRuleDatabase = resolve => require(['@/views/NavigatorRuleDatabase.vue'], resolve);
const NavigatorRuleReadiness = resolve => require(['@/views/NavigatorRuleReadiness.vue'], resolve);
const NavigatorZeroDeleter = resolve => require(['@/views/NavigatorZeroDeleter.vue'], resolve);
const Homepage = resolve => require(['@/views/Homepage.vue'], resolve);
const Callback = resolve => require(['@/views/Callback.vue'], resolve);
const NavigatorConsumptionDashboard = resolve => require(['@/views/NavigatorConsumptionDashboard.vue'], resolve);
//const NavigatorRealtimeDashboard = resolve => require(['@/views/NavigatorRealtimeDashboard.vue'], resolve);
const NavigatorValidationDashboard = resolve => require(['@/views/NavigatorValidationDashboard.vue'], resolve);
const NavigatorInterpolatorDashboard = resolve => require(['@/views/NavigatorInterpolatorDashboard.vue'], resolve);
const OidcCallback = resolve => require(['@/components/OidcCallback.vue'], resolve);
const NavigatorPublicGraphsDashboard = resolve => require(['@/views/NavigatorPublicGraphsDashboard.vue'], resolve);
const NavigatorMachineAccountsDashboard = resolve => require(['@/views/NavigatorMachineAccountsDashboard.vue'], resolve);
const NavigatorAUToolsUsersDashboard = resolve => require(['@/views/NavigatorAUToolsUsersDashboard.vue'],resolve);
const ChangelogDashboard = resolve => require(['@/views/ChangelogDashboard.vue'], resolve);
const NavigatorDatasourcesDashboard = resolve => require(['@/views/NavigatorDatasourcesDashboard.vue'], resolve);
const NavigatorDatasourcesOverviewDashboard = resolve => require(['@/views/NavigatorDatasourcesOverviewDashboard.vue'], resolve);
//const NavigatorCDDHDDDashboard = resolve => require(['@/views/NavigatorCDDHDDDashboard.vue'], resolve);
const WrikeReportsDashboard = resolve => require(['@/views/WrikeReportsDashboard.vue'], resolve);
const WrikeGeneratePublicReportsDashboard = resolve => require(['@/views/WrikeGeneratePublicReportsDashboard.vue'], resolve);

Vue.use(Router)


const router = new Router({
  mode: 'history',
  routes: [
   // {
   //   path: '/',
   //   name: 'home',
   //   component: Home
   // },
 {
    path: '/oidc-callback', // Needs to match redirectUri (redirect_uri if you use snake case) in you oidcSettings
    name: 'oidcCallback',
    component: OidcCallback
  },
    {path: '/',
     name: 'login', 
     component: NavigatorLogin
     },
     {path: '/navigatordatadashboard',
     name: 'navigatordatadashboard', 
     component: NavigatorDataDashboard,
	  beforeEnter:((to, from, next) => {
		 
		if (store.getters.loggedInState == true){
			next();
			} 
		else {
			next({name: 'login'})
			}
		})
     },
     {path: '/navigatoractivitydownloader',
     name: 'navigatoractivitydownloader', 
     component: NavigatorActivityDownloader,
	  beforeEnter:((to, from, next) => {
		 
		if (store.getters.loggedInState == true){
			next();
			} 
		else {
			next({name: 'login'})
			}
		})
     },
      {path: '/navigatorscriptdownloader',
     name: 'navigatorscriptdownloader', 
     component: NavigatorScriptDownloader,
	  beforeEnter:((to, from, next) => {
		 
		if (store.getters.loggedInState == true){
			next();
			} 
		else {
			next({name: 'login'})
			}
		})
     },
           {path: '/navigatorruledatabase',
     name: 'navigatorruledatabase', 
     component: NavigatorRuleDatabase,
	  beforeEnter:((to, from, next) => {
		 
		if (store.getters.loggedInState == true){
			next();
			} 
		else {
			next({name: 'login'})
			}
		})
     },
     {path: '/navigatordevicehealth',
     name: 'navigatordevicehealth', 
     component: NavigatorDeviceHealth,
	  beforeEnter:((to, from, next) => {
		 
		if (store.getters.loggedInState == true){
			next();
			} 
		else {
			next({name: 'login'})
			}
		})
     },
      {path: '/navigatordatadeleter',
     name: 'navigatordatadeleter', 
     component: NavigatorDataDeleter,
	  beforeEnter:((to, from, next) => {
		if (store.getters.loggedInState == true){
			if (store.getters.readOnlyStatus == false){
				next();
				}
			else {
				next({name: 'login'})
				}
			} 
		else {
			next({name: 'login'})
			}
		})
     },
	 /*
     {path: '/navigatordatahub',
     name: 'navigatordatahub', 
     component: NavigatorDataHub,
	  beforeEnter:((to, from, next) => {
		 
		if (store.getters.loggedInState == true){
			next();
			} 
		else {
			next({name: 'login'})
			}
		})
     },
	 */
     {path: '/navigatorrulereadiness',
     name: 'navigatorrulereadiness', 
     component: NavigatorRuleReadiness,
	  beforeEnter:((to, from, next) => {
		 
		if (store.getters.loggedInState == true){
			next();
			} 
		else {
			next({name: 'login'})
			}
		})
     },
     {path: '/navigatorzerodeleter',
     name: 'navigatorzerodeleter', 
     component: NavigatorZeroDeleter,
	  beforeEnter:((to, from, next) => {
		if (store.getters.loggedInState == true){
			if (store.getters.readOnlyStatus == false){
				next();
				}
			else {
				next({name: 'login'})
				}
			} 
		else {
			next({name: 'login'})
			}
		})
     },
     {path: '/navigatorconsumptiondashboard',
     name: 'navigatorconsumptiondashboard', 
     component: NavigatorConsumptionDashboard,
	  beforeEnter:((to, from, next) => {
		 
		if (store.getters.loggedInState == true){
			next();
			} 
		else {
			next({name: 'login'})
			}
		})
     },
	 /*
     {path: '/navigatorrealtimedashboard',
     name: 'navigatorrealtimedashboard',
     component: NavigatorRealtimeDashboard,
	  beforeEnter:((to, from, next) => {
		 
		if (store.getters.loggedInState == true){
			next();
			} 
		else {
			next({name: 'login'})
			}
		})
     },
	 */
     {path: '/navigatorvalidationdashboard',
     name: 'navigatorvalidationdashboard',
     component: NavigatorValidationDashboard,
	  beforeEnter:((to, from, next) => {
		 
		if (store.getters.loggedInState == true){
			next();
			} 
		else {
			next({name: 'login'})
			}
		})
     },
	 {path: '/navigatorinterpolatordashboard',
     name: 'NavigatorInterpolatorDashboard',
     component: NavigatorInterpolatorDashboard,
	  beforeEnter:((to, from, next) => {
		if (store.getters.loggedInState == true){
			if (store.getters.readOnlyStatus == false){
				next();
				}
			else {
				next({name: 'login'})
				}
			} 
		else {
			next({name: 'login'})
			}
		})
     },
	  {path: '/navigatormachineaccountsdashboard',
     name: 'NavigatorMachineAccountsDashboard',
     component: NavigatorMachineAccountsDashboard,
	  beforeEnter:((to, from, next) => {
		if (store.getters.loggedInState == true){
			if (store.getters.superUserStatus == true){
				next();
				}
			else {
				next({name: 'login'})
				}
			} 
		else {
			next({name: 'login'})
			}
		})
     },
	 
	   {path: '/navigatorautoolsusersdashboard',
     name: 'NavigatorAUToolsUsersDashboard',
     component: NavigatorAUToolsUsersDashboard,
	  beforeEnter:((to, from, next) => {
		if (store.getters.loggedInState == true){
			if (store.getters.superUserStatus == true){
				next();
				}
			else {
				next({name: 'login'})
				}
			} 
		else {
			next({name: 'login'})
			}
		})
     },
	 
	   {path: '/changelogdashboard',
     name: 'ChangelogDashboard',
     component: ChangelogDashboard,
	  beforeEnter:((to, from, next) => {
		if (store.getters.loggedInState == true){
			if (store.getters.superUserStatus == true){
				next();
				}
			else {
				next({name: 'login'})
				}
			} 
		else {
			next({name: 'login'})
			}
		})
     },
	 
	 /*
	{path: '/navigatorcddhdddashboard',
     name: 'NavigatorCDDHDDDashboard',
     component: NavigatorCDDHDDDashboard,
	  beforeEnter:((to, from, next) => {
		if (store.getters.loggedInState == true){
			if (store.getters.superUserStatus == true){
				next();
				}
			else {
				next({name: 'login'})
				}
			} 
		else {
			next({name: 'login'})
			}
		})
     },
	 	 */
	{path: '/navigatordatasourcesoverview',
     name: 'NavigatorDatasourcesOverviewDashboard',
     component: NavigatorDatasourcesOverviewDashboard,
	  beforeEnter:((to, from, next) => {
		if (store.getters.loggedInState == true){
			if (store.getters.readOnlyStatus == false){
				next();
				}
			else {
				next({name: 'login'})
				}
			} 
		else {
			next({name: 'login'})
			}
		})
     },


	{path: '/navigatordatasourcesdashboard/:id',
     name: 'NavigatorDatasourcesDashboard',
     component: NavigatorDatasourcesDashboard,
	  beforeEnter:((to, from, next) => {
		if (store.getters.loggedInState == true){
			if (store.getters.readOnlyStatus == false){
				next();
				}
			else {
				next({name: 'login'})
				}
			} 
		else {
			next({name: 'login'})
			}
		})
     },	 
	 
     
     {
      path: '/home',
      name: 'homepage',
      component: Homepage,
	   beforeEnter:((to, from, next) => {
		 
		if (store.getters.loggedInState == true){
			next();
			} 
		else {
			next({name: 'login'})
			}
		})
    },
	     {
      path: '/wrike-generate-reports',
      name: 'wrike-generate-reports',
      component: WrikeGeneratePublicReportsDashboard,
	   beforeEnter:((to, from, next) => {
		 
		if (store.getters.loggedInState == true){
			next();
			} 
		else {
			next({name: 'login'})
			}
		})
    },
	 {
      path: '/charts-data/:uuid',
      name: 'navigator-public-graphs-dashboard',
      component: NavigatorPublicGraphsDashboard,
	  meta: {
      isPublic: true
		}
    },
	
		 {
      path: '/reports/:uuid',
      name: 'wrike-reports-dashboard',
      component: WrikeReportsDashboard,
	  meta: {
      isPublic: true
		}
    },
      {
      path: '/index.html',
      redirect: "/"
    },
	
	
    
  ]
})

// very basic "setup" of a global guard

/*
	router.beforeEach((to, from, next) => {
		if (to.path !== '/login'){
	if (store.getters.loggedInState == true){
		next();
		} else {
			next({name: 'login'})
		}
		}
		else{
			next();
		}
	});  
*/

router.beforeEach(vuexOidcCreateRouterMiddleware(store))

    // if(to.name == 'callback') { 
// check if "to"-route is "callback" and allow access
//    next()
//  } else if (router.app.$auth.isAuthenticated()) { // if authenticated allow access
 //   next()
 // } else { // trigger auth0 login
//    router.app.$auth.login()
//  }
//})

export default router